import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-routlet',
    template: '<router-outlet [name]="name"></router-outlet>',
    standalone: false
})
export class RoutletComponent
{
    @Input() public name: string;
}
